const CargoGatepass = () => {
  return <div className="mt-8 px-24">Cargo Gatepass</div>;
};

export default CargoGatepass;
